import {useTranslation} from "react-i18next";
import Container from "react-bootstrap/Container";
import {Accordion} from "react-bootstrap";
import {getRatingColor} from "../../util/HelperUtils";

function About() {
  const { t, i18n } = useTranslation();

  const getEloComponentInCzech = () => {
    return (
      <Container style={{ marginTop: "2rem" }} className="third-on-desktop-full-on-mobile">
        <h2 className="mb-4">Elo systém</h2>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Co je Elo?</Accordion.Header>
            <Accordion.Body>
              Elo je systém hodnocení, který měří úroveň hráčů. Po každém zápase se hodnocení zvyšuje nebo snižuje podle toho, kdo vyhrál a jak silný byl soupeř.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>Jak probíhá výpočet změny Elo ratingu za zápas? (abstraktně)</Accordion.Header>
            <Accordion.Body>
              <ol>
                <li><b>Zjištění aktuálního ratingu hráčů:</b>
                  <ul>
                    <li>Aplikace zjistí aktuální Elo rating obou hráčů pro danou soutěž.</li>
                  </ul>
                </li>
                <li><b>Výpočet šance na výhru:</b>
                  <ul>
                    <li>Podle Elo ratingu hráčů se odhadne, jaké jsou jejich šance na výhru.</li>
                    <li>Šance na výhru rozhoduje o množství ratingu, o který se hraje.</li>
                  </ul>
                </li>
                <li><b>Počet vyhraných setů:</b>
                  <ul>
                    <li>Spočítá se, kolik setů každý hráč vyhrál. Prohrané sety v případě celkové výhry zápasu rating nijak neovlivňují.</li>
                  </ul>
                </li>
                <li><b>Přidělení bodů:</b>
                  <ul>
                    <li>Vítěz získá body. Pokud byla jeho výhra nepravděpodobná (soupeř měl vyšší rating), dostane bodů víc.</li>
                    <li>Porážený body ztrácí, ale ztratí jich míň pokud:
                      <ul>
                        <li>byla jeho výhra nepravděpodobná (soupeř měl vyšší rating)</li>
                        <li>vyhrál aspoň nějaký set (víc vyhraných setů = menši ztráta)</li>
                        <li>vítěz je nový hráč, s dosud nezkalibrovaným ratingem</li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ol>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>Jak funguje výpočet Elo? (exaktně)</Accordion.Header>
            <Accordion.Body>
              <ol>
                <li>
                  <b>Konstanty:</b>
                  <ul>
                    <li>Základ Elo: <code>32</code></li>
                    <li>Dělitel Elo: <code>400.0</code></li>
                  </ul>
                </li>
                <li>
                  <b>Vzorec pro pravděpodobnost výhry:</b>
                  <ul>
                    <li>Pravděpodobnost výhry hráče 1: <br/><code style={{paddingLeft: "1rem"}}>1 / (1 + 10^((Elo2 - Elo1) / 400))</code></li>
                    <li>Pravděpodobnost výhry hráče 2: <br/><code style={{paddingLeft: "1rem"}}>1 / (1 + 10^((Elo1 - Elo2) / 400))</code></li>
                    <ul>
                      <li>nebo zjednodušeně&nbsp;&nbsp;<code>1 - pravděpodobnost výhry hráče 1</code></li>
                    </ul>
                  </ul>
                </li>
                <li>
                  <b>Výpočet zisku/ztráty Elo:</b>
                  <ul>
                    <li>Zisk vítěze / ztráta poraženého: <br/><code style={{paddingLeft: "1rem"}}>32 * pravděpodobnost výhry hráče který prohrál</code></li>
                    <li>Pokud poražený vyhrál aspoň nějaký set, jeho ztráta se sníží o: <br />
                      <code style={{paddingLeft: "1rem"}}>0.5 * ztráta * (počet vyhraných setů / počet prohraných setů)</code>
                    </li>
                    <li>Výsledná změna je vždy zaokrouhlena na celé číslo</li>
                    <li>Pokud je vítěz nový hráč (&lt;8 zápasů), je ztráta poraženého omezena maximálně na <code>16</code></li>
                  </ul>
                </li>
                <li>
                  <b>Příklad:</b>
                  <ul>
                    <li>Hráč 1 (1250 Elo) porazil hráče 2 (1100 Elo)</li>
                    <li>Pravděpodobnost výhry hráče 1: <br/><code style={{paddingLeft: "1rem"}}>1 / (1 + 10^((1100 - 1250) / 400)) = 0.7033</code></li>
                    <li>Pravděpodobnost výhry hráče 2: <br/><code style={{paddingLeft: "1rem"}}>1 / (1 + 10^((1250 - 1100) / 400)) = 0.2966</code></li>
                    <ul>
                      <li>nebo&nbsp;&nbsp;<code>1 - 0.7033 ≃ 0.2966</code></li>
                    </ul>
                    <li>Zisk vítěze / ztráta poraženého: <br/><code style={{paddingLeft: "1rem"}}>32 * 0.7033 ~ 23</code>&nbsp;&nbsp;nebo&nbsp;&nbsp;<code>32 * 0.2966 ~ 9 </code></li>
                    <li>Pokud poražený vyhrál aspoň nějaký set, jeho ztráta se sníží o: <br />
                      <code style={{paddingLeft: "1rem"}}>0.5 * ztráta * (počet vyhraných setů / počet prohraných setů)</code>
                    </li>
                    <li>Pokud je vítěz nový hráč (&lt;8 zápasů), je ztráta omezena maximálně na <code>16</code></li>
                  </ul>
                </li>
              </ol>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>Proč se tento systém používá?</Accordion.Header>
            <Accordion.Body>
              Zajišťuje spravedlivé hodnocení dovedností. Výhra nad silným soupeřem přináší více bodů, těsná prohra tolik nebolí.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
            <Accordion.Header>Co když se změní výsledek zápasu?</Accordion.Header>
            <Accordion.Body>
              Aplikace nejprve zruší předchozí změny Elo za tento zápas a pak znovu přepočítá hodnocení, jako by byl zápas odehrán poprvé.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5">
            <Accordion.Header>Může se tento systém někdy změnit?</Accordion.Header>
            <Accordion.Body>
              Ano. Systém jsme už několikrát měnili, a může se i nadále měnit, dokud s ním nebudeme spokojeni.
              Změny byly zatím vždy aplikovány retroaktivně, takže se hodnocení hráčů vždy zpětně aktualizovalo.<br/><br/>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    );
  }

  const getEloComponentInEnglish = () => {
    return (
      <Container style={{ marginTop: "2rem" }} className="third-on-desktop-full-on-mobile">
        <h2 className="mb-4">Elo System</h2>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>What is Elo?</Accordion.Header>
            <Accordion.Body>
              Elo is a rating system that measures players' skill levels. After each match, the rating increases or decreases depending on who won and how strong the opponent was.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>How is Elo rating change calculated per match? (abstract)</Accordion.Header>
            <Accordion.Body>
              <ol>
                <li><b>Get current player ratings:</b>
                  <ul>
                    <li>The app retrieves the current Elo ratings of both players for the given league.</li>
                  </ul>
                </li>
                <li><b>Calculate win probability:</b>
                  <ul>
                    <li>Based on the Elo ratings, the system estimates each player's chance to win.</li>
                    <li>The win probability determines how many points are at stake.</li>
                  </ul>
                </li>
                <li><b>Count won sets:</b>
                  <ul>
                    <li>It calculates how many sets each player won. Lost sets don't affect the rating if the player won the match overall.</li>
                  </ul>
                </li>
                <li><b>Assign points:</b>
                  <ul>
                    <li>The winner gains points. If the win was unlikely (the opponent had a higher rating), they gain more.</li>
                    <li>The loser loses points, but less if:
                      <ul>
                        <li>their win would have been unlikely (opponent had a higher rating)</li>
                        <li>they won at least some sets (more won sets = smaller loss)</li>
                        <li>the winner is a new player with an uncalibrated rating</li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ol>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>How does the Elo calculation work? (exact)</Accordion.Header>
            <Accordion.Body>
              <ol>
                <li>
                  <b>Constants:</b>
                  <ul>
                    <li>Elo base: <code>32</code></li>
                    <li>Elo divisor: <code>400.0</code></li>
                  </ul>
                </li>
                <li>
                  <b>Win probability formula:</b>
                  <ul>
                    <li>Player 1 win probability: <br/><code style={{paddingLeft: "1rem"}}>1 / (1 + 10^((Elo2 - Elo1) / 400))</code></li>
                    <li>Player 2 win probability: <br/><code style={{paddingLeft: "1rem"}}>1 / (1 + 10^((Elo1 - Elo2) / 400))</code></li>
                    <ul>
                      <li>or simply&nbsp;&nbsp;<code>1 - Player 1 win probability</code></li>
                    </ul>
                  </ul>
                </li>
                <li>
                  <b>Elo gain/loss calculation:</b>
                  <ul>
                    <li>Winner's gain / loser's loss: <br/><code style={{paddingLeft: "1rem"}}>32 * win probability of the losing player</code></li>
                    <li>If the losing player won at least some sets, their loss is reduced by: <br />
                      <code style={{paddingLeft: "1rem"}}>0.5 * loss * (number of sets won / number of sets lost)</code>
                    </li>
                    <li>The final change is always rounded to a whole number</li>
                    <li>If the winner is a new player (&lt;8 matches), the loser's loss is capped at <code>16</code></li>
                  </ul>
                </li>
                <li>
                  <b>Example:</b>
                  <ul>
                    <li>Player 1 (1250 Elo) beats Player 2 (1100 Elo)</li>
                    <li>Player 1 win probability: <br/><code style={{paddingLeft: "1rem"}}>1 / (1 + 10^((1100 - 1250) / 400)) = 0.7033</code></li>
                    <li>Player 2 win probability: <br/><code style={{paddingLeft: "1rem"}}>1 / (1 + 10^((1250 - 1100) / 400)) = 0.2966</code></li>
                    <ul>
                      <li>or&nbsp;&nbsp;<code>1 - 0.7033 = 0.151</code></li>
                    </ul>
                    <li>Winner’s gain / loser’s loss: <br/><code style={{paddingLeft: "1rem"}}>32 * 0.2966 ~ 23</code>&nbsp;&nbsp;or&nbsp;&nbsp;<code>32 * 0.2966 ~ 9</code></li>
                    <li>If the loser won at least some sets, their loss is reduced by: <br />
                      <code style={{paddingLeft: "1rem"}}>0.5 * loss * (sets won / sets lost)</code>
                    </li>
                    <li>If the winner is a new player (&lt;8 matches), the loss is capped at <code>16</code></li>
                  </ul>
                </li>
              </ol>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>Why is this system used?</Accordion.Header>
            <Accordion.Body>
              It ensures fair skill rating. A win against a strong opponent gives more points, and a narrow loss doesn’t hurt much.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
            <Accordion.Header>What if the match result changes?</Accordion.Header>
            <Accordion.Body>
              The app first removes the previous Elo changes for the match and then recalculates the ratings as if the match was just played.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5">
            <Accordion.Header>Can this system ever change?</Accordion.Header>
            <Accordion.Body>
              Yes. We’ve already changed the system several times, and it may continue to evolve until we’re satisfied with it.
              So far, all changes have been applied retroactively, so player ratings are always updated accordingly.<br/><br/>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    );
  }

  const getScoringComponentInCzech = () => {
    return (
      <Container style={{ marginTop: "2rem" }} className="third-on-desktop-full-on-mobile">
        <h2 className="mb-4">Bodovací systém</h2>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Jak funguje bodovací systém?</Accordion.Header>
            <Accordion.Body>
              <h5>Skupinové turnaje</h5>
              Ve <b>skupinových</b> turnajích počet bodů, které hráč získá za zápas, vždy závisí na tom, kolik setů vyhrál a kolik setů prohrál.<br/>Celkově se vždy hraje o:<br/><br />
              <code>(počet vítězných setů * 2) - 1</code>&nbsp;&nbsp;bodů.<br/><br/>Hráč, který prohraje, získá za každý vyhraný set 1 bod, zbytek bodů získá vítěz.<br/><br/>
              <h5>Švýcarský systém</h5>
              V turnajích se <b>švýcarským systémem</b> každý hráč dostane tolik bodů, kolik setů vyhrál, a prohrané sety body už neovlivňují. Hráč, který zápas vyhrál, pak ještě dostane jeden bonusový bod.<br/>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>Co se stane, když má několik hráčů stejný počet bodů?</Accordion.Header>
            <Accordion.Body>
              V případě shody bodů se rozlišují dva případy:
              <ul>
                <li>Pokud se všichni hráči s daným skóre utkali, vytvoří se "minitabulka" s pouze těmito hráči a jejich vzájemnými zápasy, a hráči se podle ní seřadí. Pokud i v této tabulce budou mít hráči stejné skóre, řadí se podle pravidla níže.</li>
                <li>V opačném případě se hráči seřadí podle následujících parametrů (vyhodnocovaných v tomto pořadí shora dolů):</li>
                <ul>
                  <li>Počet vyhraných zápasů</li>
                  <li>Buchholz skóre</li>
                  <li>Počet vyhraných setů</li>
                  <li>Rozdíl míčků (vyhrnané minus prohrané)</li>
                </ul>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>Co je Buchholz skóre?</Accordion.Header>
            <Accordion.Body>
              Buchholz skóre je pomocné hodnocení používané při švýcarském systému turnajů. Vypočítává se jako součet bodů všech soupeřů, proti kterým hráč hrál.<br/><br/>
              Čím silnější soupeře měl hráč během turnaje, tím vyšší má Buchholz skóre.
              Buchholz skóre se zvyšuje i v případě, že hráč proti danému soupeři prohrál. Pokud se tedy hráč utká s velmi silným soupeřem a prohraje, jeho Buchholz skóre bude vyšší než u hráče, který porazil slabšího soupeře.<br/><br/>
              Buchholz skóre se navyšuje i za body, které soupeř získá až po tom, co s ním hráč hrál.<br/><br/>
              V tabulkách se Buchholz skóre zobrazuje v závorce za celkovým počtem bodů hráče.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    );
  }

  const getScoringComponentInEnglish = () => {
    return (
      <Container style={{ marginTop: "2rem" }} className="third-on-desktop-full-on-mobile">
        <h2 className="mb-4">Scoring System</h2>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>How does the scoring system work?</Accordion.Header>
            <Accordion.Body>
              <h5>Group system tournaments</h5>
              In <b>group system</b> tournaments, the number of points a player earns from a match always depends on how many sets they won and lost.<br />
              In total, each match is worth:<br /><br />
              <code>(number of winning sets * 2) - 1</code>&nbsp;&nbsp;points.<br /><br />
              The losing player earns 1 point for each set they won, and the remaining points go to the winner.<br /><br />
              <h5>Swiss system tournaments</h5>
              In the <b>Swiss system</b> tournaments each player now gets as many points as the number of sets they have won, and lost sets do not affect the points. The player who won the match then also receives one bonus point.<br />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>What if multiple players have the same number of points?</Accordion.Header>
            <Accordion.Body>
              In the case of tied scores, two scenarios are considered:
              <ul>
                <li>
                  If all players with the same score played against each other, a "mini table" is created including only these players and their head-to-head matches, and they are ranked based on that. If they are still tied, the rule below applies.
                </li>
                <li>
                  Otherwise, the players are ranked based on the following criteria (evaluated in this order, from top to bottom):
                </li>
                <ul>
                  <li>Number of matches won</li>
                  <li>Buchholz score</li>
                  <li>Number of sets won</li>
                  <li>Point difference (points won minus points lost)</li>
                </ul>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>What is the Buchholz score?</Accordion.Header>
            <Accordion.Body>
              The Buchholz score is a tie-breaking method used in Swiss-system tournaments. It is calculated as the sum of points of all opponents the player has faced.<br /><br />
              The stronger the opponents a player has faced during the tournament, the higher their Buchholz score will be.
              The Buchholz score increases even if the player loses to the opponent. So if a player loses to a very strong opponent, their Buchholz score will be higher than a player who beat a weaker opponent.<br /><br />
              The Buchholz score also increases as the opponents earn more points later in the tournament, even after the match has been played.<br /><br />
              In score tables, the Buchholz score is shown in parentheses after the player's total points.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    );
  };

  const getLoginComponentInCzech = () => {
    return (
      <Container style={{ marginTop: "2rem" }} className="third-on-desktop-full-on-mobile">
        <h2 className="mb-4">Uživatelské účty</h2>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Jak fungují uživatelské účty?</Accordion.Header>
            <Accordion.Body>
              Uživatelské účty si narozdíl od hráčských profilů můžete vytvořit sami. Stačí kliknout na tlačítko "Přihlásit se" v horní části stránky a následně na "Vytvořit účet".<br/><br/>
              Po vytvoření profilu požádejte některého z administrátorů o propojení uživatelského účtu s vaším hráčským profilem. Díky tomu budete moci zadávat výsledky zápasů samostatně, používat chat, a v budoucnu i další funkce.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>Co dělat, když zapomenu heslo?</Accordion.Header>
            <Accordion.Body>
              Momentálně není možné si heslo resetovat samostatně. Pokud zapomenete heslo, kontaktujte některého z administrátorů a požádejte ho o reset hesla.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>Co dělat, když zapomenu přihlašovací jméno?</Accordion.Header>
            <Accordion.Body>
              Kontaktujte některého z administrátorů a on Vám Vaše jméno dohledá.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>Je moje heslo uloženo bezpečně?</Accordion.Header>
            <Accordion.Body>
              Hesla jsou před uložením do databáze zašifrovaná jednosměrnou šifrou, nikdo se na ně tedy nemůže zpětně podívat.<br/><br/>I tak je ale obecně bezpečnější nepoužívat stejné heslo na více místech, tak si pro tento web raději vymyslete nějaké speciální hravé heslo. :)
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    );
  }

  const getLoginComponentInEnglish = () => {
    return (
      <Container style={{ marginTop: "2rem" }} className="third-on-desktop-full-on-mobile">
        <h2 className="mb-4">User Accounts</h2>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>How do user accounts work?</Accordion.Header>
            <Accordion.Body>
              Unlike player profiles, you can create user accounts yourself. Just click the "Log In" button at the top of the page and then select "Create Account".<br /><br />
              After creating your account, ask one of the administrators to link your user account to your player profile. This will allow you to submit match results on your own, use the chat, and access more features in the future.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>What should I do if I forget my password?</Accordion.Header>
            <Accordion.Body>
              At the moment, it's not possible to reset your password on your own. If you forget your password, contact one of the administrators and ask them to reset it for you.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>What if I forget my username?</Accordion.Header>
            <Accordion.Body>
              Contact one of the administrators and they will look up your username for you.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>Is my password stored securely?</Accordion.Header>
            <Accordion.Body>
              Passwords are encrypted with a one-way hash before being stored in the database, so no one can view them afterward.<br /><br />
              Still, it’s generally safer not to reuse the same password across multiple sites, so we recommend creating a fun and unique password just for this site. :)
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    );
  };

  const getRatingComponentInCzech = () => {
    return (
      <Container style={{ marginTop: "2rem" }} className="third-on-desktop-full-on-mobile">
        <h2 className="mb-4">Výkonnostní rating</h2>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Co je to výkonnostní rating?</Accordion.Header>
            <Accordion.Body>
              Výkonnostní rating slouží k hodnocení výkonu hráčů v zápasech a turnajích,
              přičemž bere v úvahu také sílu soupeřů, proti kterým hráli.
              Jeho cílem je co nejlépe vystihnout, jak se hráčům v jednotlivých zápasech dařilo –
              bez ohledu na jejich konečné umístění v turnaji.
              <br /><br />
              Hráči si mohou své zápasové ratingy prohlédnout na svých profilech.
              Turnajové ratingy jsou pak dostupné jak na profilech,
              tak i v detailu jednotlivých turnajů v záložce <b>„Rating“</b>.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>Jak se počítá zápasový rating?</Accordion.Header>
            <Accordion.Body>
              Při výpočtu ratingu se bere v potaz Elo rating obou hráčů,
              výsledky jednotlivých setů (tedy nejen výhra/prohra, ale i samotné body),
              a samozřejmě i celkový výsledek zápasu.
              <br /><br />
              Obecně tedy platí:
              <ul>
                <li>
                  Rating se <b>zvyšuje</b>, pokud hráč:
                  <ul>
                    <li>Vyhraje bod</li>
                    <li>Vyhraje set</li>
                    <li>Vyhraje zápas</li>
                    <li>Má nižší Elo rating než soupeř</li>
                  </ul>
                </li>
                <li>
                  Rating se <b>snižuje</b>, pokud hráč:
                  <ul>
                    <li>Prohraje bod</li>
                    <li>Prohraje set</li>
                    <li>Prohraje zápas</li>
                    <li>Má vyšší Elo rating než soupeř</li>
                  </ul>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>Jak se počítá turnajový rating?</Accordion.Header>
            <Accordion.Body>
              Turnajový rating je jednoduše <b>aritmetický průměr všech zápasových ratingů</b> daného hráče v turnaji.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>Co znamenají jednotlivé barvy ratingu?</Accordion.Header>
            <Accordion.Body>
              Aby bylo možné snadno rozlišit různé úrovně výkonu, mění se barva ratingu podle jeho hodnoty.
              <br /><br />
              Hraniční hodnoty pro jednotlivé barvy jsou následující:
              <ul>
                <li>
                  <span style={{ color: getRatingColor(0.8) }}>Šedá</span> – Slabý výkon (rating menší než 1)
                </li>
                <li>
                  <span style={{ color: getRatingColor(1.1) }}>Zelená</span> – Dobrý výkon (rating od 1 do 1.5)
                </li>
                <li>
                  <span style={{ color: getRatingColor(1.6) }}>Fialová</span> – Skvělý výkon (rating od 1.5 do 1.75)
                </li>
                <li>
                  <span style={{ color: getRatingColor(1.8) }}>Zlatá</span> – Výborný výkon (rating od 1.75 do 2)
                </li>
                <li>
                  <span style={{ color: getRatingColor(2.1) }}>Černá</span> – Totální dominance (rating vyšší než 2)
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    );
  };

  const getRatingComponentInEnglish = () => {
    return (
      <Container style={{ marginTop: "2rem" }} className="third-on-desktop-full-on-mobile">
        <h2 className="mb-4">Performance Rating</h2>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>What is the performance rating?</Accordion.Header>
            <Accordion.Body>
              The performance rating is used to evaluate how well players perform in matches and tournaments,
              while also taking into account the strength of their opponents.
              Its goal is to capture how well each player performed in their matches –
              regardless of their final placement in the tournament.
              <br /><br />
              Players can view their match ratings on their profiles.
              Tournament ratings are also available both on player profiles
              and in each tournament’s detail page under the <b>“Rating”</b> tab.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>How is the match rating calculated?</Accordion.Header>
            <Accordion.Body>
              The match rating is based on several factors — the Elo ratings of both players,
              the results of individual sets (including both wins/losses and the number of points scored),
              and the final outcome of the match.
              <br /><br />
              In general:
              <ul>
                <li>
                  The rating <b>increases</b> when a player:
                  <ul>
                    <li>Wins a point</li>
                    <li>Wins a set</li>
                    <li>Wins the match</li>
                    <li>Has a lower Elo rating than the opponent</li>
                  </ul>
                </li>
                <li>
                  The rating <b>decreases</b> when a player:
                  <ul>
                    <li>Loses a point</li>
                    <li>Loses a set</li>
                    <li>Loses the match</li>
                    <li>Has a higher Elo rating than the opponent</li>
                  </ul>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>How is the tournament rating calculated?</Accordion.Header>
            <Accordion.Body>
              The tournament rating is simply the <b>average of all match ratings</b> a player earned during the tournament.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>What do the different rating colors mean?</Accordion.Header>
            <Accordion.Body>
              To make rating levels easier to read at a glance, each rating value is represented by a color.
              <br /><br />
              The color thresholds are as follows:
              <ul>
                <li>
                  <span style={{ color: getRatingColor(0.8) }}>Gray</span> – Weak performance (rating below 1)
                </li>
                <li>
                  <span style={{ color: getRatingColor(1.1) }}>Green</span> – Good performance (rating between 1 and 1.5)
                </li>
                <li>
                  <span style={{ color: getRatingColor(1.6) }}>Purple</span> – Great performance (rating between 1.5 and 1.75)
                </li>
                <li>
                  <span style={{ color: getRatingColor(1.8) }}>Gold</span> – Outstanding performance (rating between 1.75 and 2)
                </li>
                <li>
                  <span style={{ color: getRatingColor(2.1) }}>Black</span> – Total domination (rating above 2)
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    );
  };

  return (
    <div className="base-container">
      <div className="table-header header">
        <span className="table-title">{t("about")}</span>
      </div>
      <div>
        { i18n.language === "cs" ? getLoginComponentInCzech() : getLoginComponentInEnglish() }
        { i18n.language === "cs" ? getScoringComponentInCzech() : getScoringComponentInEnglish() }
        { i18n.language === "cs" ? getEloComponentInCzech() : getEloComponentInEnglish() }
        { i18n.language === "cs" ? getRatingComponentInCzech() : getRatingComponentInEnglish() }
      </div>
    </div>
  );
}

export default About
